import React, { useId } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "../../shadcn/components/ui/dialog";
import { useTranslation } from "../../context/Internationalization";

const MediaPreviewModal = ({ open, onClose, title, children, actions }) => {
  const { t } = useTranslation();
  const titleId = useId();
  const resolvedTitle = title || t("file");

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogContent
        aria-labelledby={titleId}
        closeLabel={t("close")}
        className="flex h-[min(680px,calc(100vh-32px))] max-h-[calc(100vh-32px)] w-[calc(100%-32px)] max-w-[880px] flex-col gap-0 overflow-hidden rounded-3xl p-0 supports-[height:100dvh]:h-[min(680px,calc(100dvh-32px))] supports-[height:100dvh]:max-h-[calc(100dvh-32px)] sm:max-w-[880px]"
      >
        <DialogTitle
          id={titleId}
          className="shrink-0 overflow-hidden py-4 pr-16 pl-6 text-xl leading-normal text-ellipsis whitespace-nowrap"
          title={resolvedTitle}
        >
          {resolvedTitle}
        </DialogTitle>
        <div className="flex min-h-0 min-w-0 flex-1 items-center justify-center overflow-hidden px-4 pb-4 sm:px-6 [&>img]:block [&>img]:h-full [&>img]:min-h-0 [&>img]:w-full [&>img]:rounded-lg [&>img]:object-scale-down [&>video]:block [&>video]:h-full [&>video]:min-h-0 [&>video]:w-full [&>video]:rounded-lg [&>video]:object-scale-down">
          {children}
        </div>
        {actions && (
          <div className="flex max-h-[45%] shrink-0 flex-col items-start gap-2 overflow-y-auto px-4 pb-4 sm:px-6">
            {actions}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default MediaPreviewModal;
